import analytics from '@utils/analytics';
import api from '@utils/api';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
const ProductDiscoverMore = (props) => {
    const { t } = useTranslation();
    const current = useSelector((state) => state.product).current;
    const [previousMaster, setpreviousMaster] = useState('');
    const [hasDiscoverMore, setHasDiscoverMore] = useState(false);
    const [discoverMoreUrl, setDiscoverMoreUrl] = useState('/');
    useEffect(() => {
        var _a, _b;
        if (current === null || current === void 0 ? void 0 : current.technicalPage) {
            if (current.masterId != previousMaster) {
                setpreviousMaster(current.masterId);
                api.getPageJson(current.technicalPage).then((data) => {
                    var _a;
                    if (!data.errorMessage) {
                        setDiscoverMoreUrl((_a = data.page) === null || _a === void 0 ? void 0 : _a.url);
                        setHasDiscoverMore(true);
                    }
                });
            }
        }
        else if ((current === null || current === void 0 ? void 0 : current.isParfum) && ((_a = current === null || current === void 0 ? void 0 : current.parfumAttributes) === null || _a === void 0 ? void 0 : _a.perfumePageID)) {
            if (current.masterId != previousMaster) {
                setpreviousMaster(current.masterId);
                api.getPageJson((_b = current === null || current === void 0 ? void 0 : current.parfumAttributes) === null || _b === void 0 ? void 0 : _b.perfumePageID).then((data) => {
                    var _a;
                    if (!data.errorMessage) {
                        setDiscoverMoreUrl((_a = data.page) === null || _a === void 0 ? void 0 : _a.url);
                        setHasDiscoverMore(true);
                    }
                });
            }
        }
        else if (current === null || current === void 0 ? void 0 : current.adidasImmPageID) {
            if (current.masterId != previousMaster) {
                setpreviousMaster(current.masterId);
                api.getPageJson(current === null || current === void 0 ? void 0 : current.adidasImmPageID).then((data) => {
                    var _a;
                    if (!data.errorMessage) {
                        setDiscoverMoreUrl((_a = data.page) === null || _a === void 0 ? void 0 : _a.url);
                        setHasDiscoverMore(true);
                    }
                });
            }
        }
        else {
            // al cambio pdp (routing client side) resetto il discover more
            setHasDiscoverMore(false);
        }
    }, [current]);
    const onClickAnalytics = () => {
        (current === null || current === void 0 ? void 0 : current.isParfum) ? analytics.discoverMoreParfum(current.id) : undefined;
    };
    return hasDiscoverMore ? (React.createElement("div", { className: 'product-selection discover-more container' + (!props.loaded ? ' landing' : '') },
        React.createElement("div", { className: "row justify-center" },
            React.createElement("div", { className: "col-lg-8 col-md-12 col-sm-10" },
                React.createElement("div", { className: "text-center" },
                    React.createElement("p", null, (current === null || current === void 0 ? void 0 : current.isParfum) ? t('button.discovermoreperfumes') : (current === null || current === void 0 ? void 0 : current.adidasImmPageID) ? t('button.discovermoreadidas') : t('button.discovermoretechnical')),
                    React.createElement("a", { onClick: onClickAnalytics, href: discoverMoreUrl, target: (current === null || current === void 0 ? void 0 : current.adidasImmPageID) ? '_blank' : '_self', className: "button button--tertiary button--arrow-right", "aria-hidden": !!(current === null || current === void 0 ? void 0 : current.isParfum) }, (current === null || current === void 0 ? void 0 : current.isParfum) ? t('button.discovermorelink') : (current === null || current === void 0 ? void 0 : current.adidasImmPageID) ? t('button.discovermoreadidaslink') : t('button.discovermore'))))))) : (React.createElement(React.Fragment, null));
};
export default ProductDiscoverMore;
